import React, {useCallback, useContext, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {
	Accordion,
	AccordionActions,
	AccordionDetails,
	AccordionSummary,
	Tooltip
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import Grid from "@mui/material/Grid";
import {useForm, FormProvider} from "react-hook-form";
import Button from "@mui/material/Button";
import {capitalizeWords} from "../../../../utils/GenericUtils";
import {AnagraficaContext, AppContext} from "../../../../App";
import {useTheme} from "@mui/styles";
import {resetAnagrafica} from "../../interviste/intervista/utils/ResetUtils";
import {updateAnagrafica} from "../../../../services/AnagraficaServices";
import {useHistory, useParams} from "react-router-dom";
import {getAnaGraficaApi} from "../../../../services/utils/TicketApiData";
import {setOpenSnackbar} from "../../../../services/AppServices";

const AnagraficaAccordion = ({quarantena, selectSoggetto}) => {
	const classes = BaseStyle();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	let theme = useTheme();
	let {idSoggetto} = useParams();
	let history = useHistory();
	const [submit, setSubmit] = useState(false);
	const methods = useForm({
		mode: "onChange",
		defaultValues: resetAnagrafica(quarantena.soggetto)
	});
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		updateAnagrafica(getAnaGraficaApi({...quarantena.soggetto, ...data}), quarantena.soggetto.idSoggetto, anagraficaContext.dispatch);
	}, [anagraficaContext.dispatch, quarantena])
	
	/*useEffect(() => {
		getAllRelazioniBySoggetto(quarantena.soggetto.idSoggetto, anagraficaContext.dispatch);
	}, [quarantena.soggetto.idSoggetto, anagraficaContext.dispatch])*/
	
	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Anagrafica aggiornata correttamente", appContext.dispatch);
		} else if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica !== "") {
			setSubmit(false);
			setOpenSnackbar("error", anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch);
		}
	}, [submit, anagraficaContext.state.errorUpdateAnagrafica, anagraficaContext.state.loadingUpdateAnagrafica, appContext.dispatch])
	
	return (
		<React.Fragment>
			<Accordion
				onClick={
					(!idSoggetto || idSoggetto?.toString() === quarantena.soggetto.idSoggetto?.toString()) ? () => {
					} : () => selectSoggetto(quarantena)}
				expanded={!idSoggetto || idSoggetto?.toString() === quarantena.soggetto.idSoggetto?.toString()}
				style={{borderRadius: 24}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon/>}
				>
					<Typography
						component={"div"}
						className={classes.heading}><b>{quarantena?.tipo === "Quarantena" ? "Autosorveglianza" : quarantena.tipo}</b>
						<br/>
						<span style={idSoggetto?.toString() === quarantena.soggetto.idSoggetto?.toString() ? {
							fontSize: 30,
							color: theme.palette.primary.main,
							fontWeight: "bold"
						} : {}}>
						{capitalizeWords(quarantena.soggetto?.nome) + " " + capitalizeWords(quarantena.soggetto?.cognome)}
							</span>
					</Typography>
				</AccordionSummary>
				<AccordionDetails style={{display: "block"}}>
					<FormProvider {...methods}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<Grid container spacing={3}>
								<AnagraficaCompleta moreInfo={true} intro={"false"} anagrafica={quarantena.soggetto} classes={classes}/>
							</Grid>
						</form>
					</FormProvider>
				</AccordionDetails>
				<AccordionActions className={classes.flexRight}>
					<Tooltip
						title={"Vai alla pagina della gestione del singolo paziente. L'oggetto che hai aperto (ticket, focolaio, ...) rimarrà comunque \"In gestione\" da te, pertanto ricordatene!"}>
						<Button variant={"text"} disableElevation size="small" type={"submit"}
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={() => history.push("/gestione/pazienti/" + idSoggetto)}>
							<b>Dettaglio paziente</b>
						</Button>
					</Tooltip>
					<Tooltip
						title={"Aggiorna l'anagrafica paziente"}>
						<Button variant={"contained"} disableElevation size="small" color="primary" type={"submit"}
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
							<b>Aggiorna anagrafica</b>
						</Button>
					</Tooltip>
				</AccordionActions>
			</Accordion>
		</React.Fragment>
	);
}

export default React.memo(AnagraficaAccordion);
